import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import React from 'react';
import { CreditAgeTradeLineComponent } from 'components/FactorTradelineComponent/CreditAgeFactorTradeline/CreditAgeTradelineComponent';
import GradesGoalGraph from 'components/Fragments/GradesGoalGraph';
import { monthsToYears } from 'helpers/dateHelper';
import { DateText } from 'components/DateText/DateText';
import { useConfig } from 'hook/config.hook';

const CreditAgeSummaryModuleView = props => {
  const {
    newestTradeline,
    oldestTradeline,
    userInfo,
    selectedBureau,
    creditInfo,
    profileContainer,
    creditReports,
  } = props;
  const { config } = useConfig();
  const { creditAge } = creditInfo?.creditScoreAnalysis;
  const { creditScore } = creditInfo;
  const isFirstTimeCreditUser = creditScore === 4 ? true : false;
  const totalMonths = monthsToYears(creditAge?.avgAccountAge);
  const textTotalMonths = totalMonths === 0 ? '0 Yrs' : totalMonths;
  const strYearMonth = isFirstTimeCreditUser ? '--' : textTotalMonths;
  const grade = isFirstTimeCreditUser ? '--' : creditAge?.grade;
  const tipsArray = config?.tips?.factors?.creditAge?.tips?.filter(
    t => t.grade === grade,
  );
  const [tips] = tipsArray;
  return (
    <FlexContainer className={'flex-column'}>
      <FlexContainer className={'flex-column margtb20 marglr48 m-marglr16'}>
        <Label type="Body-2" className={'text-14'}>
          {tips?.description}
        </Label>
      </FlexContainer>
      <FlexContainer
        className={'flex-column margtb20 marglr48 m-marglr16 bold'}
      >
        <DateText
          date={
            isFirstTimeCreditUser
              ? config?.dateText?.creditDuration
              : strYearMonth
          }
        />
      </FlexContainer>
      <FlexContainer
        className={'flex-column margtb20 marglr48 m-marglr16 bold'}
      >
        <GradesGoalGraph you={grade} goal={creditAge.grade} type="age" />
      </FlexContainer>
      <FlexContainer className={'flex-column'}>
        <FlexContainer className={'bgNeutral025 margt20'}>
          <Label type="Body-2" className={'bold margtb8 margl10 text-12'}>
            OLDEST OPEN ACCOUNT
          </Label>
        </FlexContainer>
        <FlexContainer className={'flex-column marglr48 m-marglr16'}>
          <CreditAgeTradeLineComponent
            tradeline={oldestTradeline}
            selectedBureau={selectedBureau}
            userInfo={userInfo}
            profileContainer={profileContainer}
            creditReports={creditReports}
            isSuccess
          />
        </FlexContainer>
      </FlexContainer>
      <FlexContainer className={'flex-column'}>
        <FlexContainer className={'bgNeutral025 margt20'}>
          <Label type="Body-2" className={'bold margtb8 margl10 text-12'}>
            NEWEST OPEN ACCOUNT
          </Label>
        </FlexContainer>
        <FlexContainer className={'flex-column marglr48 m-marglr16'}>
          <CreditAgeTradeLineComponent
            tradeline={newestTradeline}
            selectedBureau={selectedBureau}
            userInfo={userInfo}
            profileContainer={profileContainer}
            creditReports={creditReports}
            isSuccess
          />
        </FlexContainer>
      </FlexContainer>
    </FlexContainer>
  );
};

export default CreditAgeSummaryModuleView;
